<template>
  <div class="yxtBiz-calendar">
    <div class="yxtBiz-calendar-header">
      <div class="yxtBiz-calendar-header-prev" @click="selectDate('prev')"><i class="yxt-icon-arrow-left"></i></div>
      <div class="yxtBiz-calendar-header-title"><span>{{ language().msg_calendar_info.replace('$year', presentDay.year).replace('$month', formatMonth(presentDay.month)).replace('$week', presentDay.week) }}</span></div>
      <div class="yxtBiz-calendar-header-next" @click="selectDate('next')"><i class="yxt-icon-arrow-right"></i></div>
    </div>
    <div class="yxtBiz-calendar-body" key="no-range">
      <table class="yxtBiz-calendar-table">
        <thead class="yxtBiz-calendar-thead">
          <th v-for="(day, index) in sevenDay" :key="index">{{day}}</th>
        </thead>
        <tbody class="yxtBiz-calendar-tbody">
          <tr>
            <td v-for="(weekday,index) in presentWeek" :key="index">
              <div @click="handleGetActiveDay(weekday.value)" :class="{'yxtBiz-calendar-tbody-active':dayActive(weekday.value),'yxtBiz-calendar-tbody-today':dayToday(weekday.value)}"><span>{{weekday.label}}</span></div>
              <span :class="{'yxtBiz-calendar-table-dot':dotDays.indexOf(DateToStr(weekday.value))>-1}"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupCalendar',
  inject: ['language'],
  props: {
    // 当前选中时间
    value: {
      type: String,
      default: '2022-03-27'
    },
    // 需要加点的日期
    dotDays: {
      type: Array,
      default: []
    }
  },
  computed: {
    realSelectedDay: {
      get() {
        if (!this.value) return this.selectedDay;
        return this.formatedDate;
      },
      set(val) {
        this.selectedDay = val;
        const date = new Date(val);
        this.$emit('input', date);
      }
    }
  },

  watch: {
    dayActiveInfo: {
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.$emit('input', new Date(value));
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      presentDate: undefined,
      dayActiveInfo: new Date(this.value),
      presentDay: {
        year: 2000,
        month: 0,
        week: 0,
        date: 0
      },
      presentWeek: [{}],
      sevenDay: [this.language().lbl_su, this.language().lbl_mo, this.language().lbl_tu, this.language().lbl_we, this.language().lbl_th, this.language().lbl_fr, this.language().lbl_sa]
    };
  },

  created() {
    // 获取上面年月日
    this.handleGetToday(new Date());
    // 获取下面该周信息
    // 本周最后一天
    let w = new Date().getDay();;
    let WeekFirstDay = new Date(new Date().getTime() + (6 - w) * 86400000);
    this.getWeekDate(WeekFirstDay);

  },

  methods: {
    formatMonth(value) {
      return value < 10 ? ('0' + String(value)) : String(value);
    },
    handleGetToday(val) {
      if ((val >= new Date() && val <= new Date(new Date().getTime() + 6 * 1000 * 3600 * 24))) {
        this.presentDate = new Date();
      } else {
        this.presentDate = val;
      }
      this.presentDay.year = this.presentDate.getFullYear();
      this.presentDay.month = this.presentDate.getMonth() + 1;
      this.presentDay.date = this.presentDate.getDate();
      this.presentDay.week = this.getMonthWeek(this.presentDay.year, this.presentDay.month, this.presentDay.date);
    },

    selectDate(type) {
      let Stamp = this.presentWeek[6].value;
      // let num = 7 - Stamp.getDay();
      if (type === 'next') {
        Stamp.setDate(Stamp.getDate() + 7);
      } else {
        Stamp.setDate(Stamp.getDate() - 7);
      }
      this.handleGetToday(Stamp);
      this.getWeekDate(Stamp);
    },

    // 获得当前日期在当月第几周
    /**
     * a 年
     * b 月
     * c 日
     */
    getMonthWeek(a, b, c) {
      /*
      a = d = 当前日期
      b = 6 - w = 当前周的还有几天过完(不算今天)
      a + b 的和在除以7 就是当天是当前月份的第几周
      */
      let date = this.presentDate;
      let w = date.getDay();
      let d = date.getDate();
      // 要是上取整不含第一周，那就Math.ceil
      return Math.ceil((d + 6 - w) / 7);
    },

    // 获取下面本周周日-周六信息
    getWeekDate(WeekFirstDay) {
      this.presentWeek = [{}, {}, {}, {}, {}, {}, {}];
      this.presentWeek[6].value = WeekFirstDay;
      this.presentWeek[6].label = (WeekFirstDay.getDate() < 10 ? '0' + WeekFirstDay.getDate() : String(WeekFirstDay.getDate()));
      for (var i = 5; i >= 0; i--) {
        const value = new Date((WeekFirstDay / 1000 - (6 - i) * 86400) * 1000);
        this.presentWeek[i].value = value;
        this.presentWeek[i].label = value.getDate() < 10 ? '0' + value.getDate() : String(value.getDate());
      }
      // 区间
      this.$emit('week', this.presentWeek[0].value, this.presentWeek[6].value);
    },

    dayToday: function(value) {
      return value.toLocaleDateString() === new Date().toLocaleDateString();
    },

    dayActive: function(value) {
      let activeShow = false;
      if (this.dayActiveInfo) {
        if (value.toLocaleDateString() === this.dayActiveInfo.toLocaleDateString()) {
          activeShow = true;
        }
      }
      return activeShow;
    },

    handleGetActiveDay(value) {
      this.dayActiveInfo = value;
    },

    // 日期转字符串格式
    DateToStr(date) {
      var year = date.getFullYear(); // 年
      var month = date.getMonth(); // 月
      var day = date.getDate(); // 日
      return year + '-' + ((month + 1) > 9 ? (month + 1) : '0' + (month + 1)) + '-' + (day > 9 ? day : ('0' + day));
    }
  }
};
</script>

<style lang="scss" scoped>
.yxtBiz-calendar{
  margin: 14px 24px 3px;
  .yxtBiz-calendar-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .yxtBiz-calendar-header-prev,.yxtBiz-calendar-header-next{
      width: 18px;
      height: 18px;
      border-radius: 9px;
      background: #D9D9D9;
      color: #FFFFFF;
      cursor: pointer;
      .yxt-icon-arrow-left,.yxt-icon-arrow-right{
        position: relative;
        font-size: 10px;
        top: -2px;
      }
      .yxt-icon-arrow-left{
        left:2.5px
      }
      .yxt-icon-arrow-right{
        left:3px
      }
    }
    .yxtBiz-calendar-header-prev:hover,.yxtBiz-calendar-header-next:hover{
      background:  var(--color-primary);
    }
    .yxtBiz-calendar-header-title{
      font-size: 16px;
      color: #262626;
      line-height: 24px;
    }
  }
  .yxtBiz-calendar-table{
    width: 100%;
    margin-top: 16px;
    table-layout: fixed;
    .yxtBiz-calendar-thead{
      font-size: 14px;
      line-height: 32px;
      th{
        width: 30px;
        text-align: center;
      }
    }
    .yxtBiz-calendar-tbody{
      color: #8C8C8C;
      vertical-align: top;
      >tr>td>div{
        width: 30px;
        height: 30px;
        margin: 0 auto;
        border-radius: 15px;
        border: 1px solid transparent;
        box-sizing: border-box;
      }
      >tr>td>div:hover{
        border: 1px solid var(--color-primary);
        color:#262626;
      }
      .yxtBiz-calendar-tbody-today{
        border: 1px solid var(--color-primary);
        color:#262626;
      }
      .yxtBiz-calendar-tbody-active{
        width: 30px;
        height: 30px;
        margin: 0 auto;
        border-radius: 15px;
        background:  var(--color-primary);
        color:#FFFFFF;
        box-sizing: border-box;
      }
      td{
        text-align: center;
        cursor: pointer;
        div{
          line-height: 30px;
        }
        .yxtBiz-calendar-table-dot{
          width: 4px;
          height: 4px;
          background: var(--color-primary);
          border-radius: 3px;
          display: inline-block;
          position: relative;
          top:-10px
        }
      }
    }
  }
}
</style>
